import { blog4, blog5, blog6 } from 'assets/images';

const BlogContent = [
    {
        images: '01',
        title: 'Infinity Comics finally launches its operations!',
        category: 'Features',
        img: blog4,
        link: '#'
    },
    {
        images: '02',
        title: 'The time for African On Demand media Content is now',
        category: 'New',
        img: blog5,
        link: '#'
    },

    {
        images: '03',
        title: 'Comedy in Uganda is being re branded',
        category: 'Features',
        img: blog6,
        link: '#'
    }
]

export default BlogContent;
